module.exports = __webpack_public_path__ + "static/media/ico_care.90f16b36.svg";